export const api = {
  rootUrl: window.APP_CONFIG.ASSESS_API_URL,
  maxFileBytes: parseInt(window.APP_CONFIG.AWS_S3_FILE_SIZE_LIMIT || '20000000', 10),
};
